const Feedback = ({ player }) => {
  // Helper function to render feedback responses
  const renderFeedbackResponses = (responses) => {
    if (!responses || responses.length === 0) {
      return (
        <span style={{ color: "#666", fontStyle: "italic" }}>No responses</span>
      );
    }

    return (
      <div style={{ marginTop: "8px" }}>
        {responses.map((response, idx) => (
          <div
            key={idx}
            style={{
              marginBottom: "8px",
              padding: "8px",
              backgroundColor: "#f8f9fa",
              borderRadius: "4px",
            }}
          >
            <div style={{ fontWeight: "500" }}>{response.question}</div>
            <div style={{ marginTop: "4px" }}>{response.feedback}</div>
            <div
              style={{
                fontSize: "12px",
                color: "#666",
                marginTop: "4px",
                textAlign: "right",
              }}
            >
              {new Date(response.submitted_at).toLocaleString()}
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div
      style={{
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      <h3
        style={{
          fontSize: "24px",
          fontWeight: "600",
          color: "#50868f",
          marginBottom: "20px",
          paddingBottom: "10px",
          borderBottom: "2px solid #50868f",
        }}
      >
        {player.name}'s Feedback & Support Requests
      </h3>

      {player.feedback.length === 0 ? (
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
          }}
        >
          <p style={{ color: "#666", fontStyle: "italic" }}>
            No feedback or support requests yet
          </p>
        </div>
      ) : (
        <div
          style={{
            borderRadius: "8px",
            overflow: "hidden",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              backgroundColor: "#fff",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    backgroundColor: "#50868f",
                    color: "#fff",
                    padding: "16px",
                    textAlign: "left",
                    width: "15%",
                  }}
                >
                  Request ID
                </th>
                <th
                  style={{
                    backgroundColor: "#50868f",
                    color: "#fff",
                    padding: "16px",
                    textAlign: "left",
                    width: "25%",
                  }}
                >
                  Reason
                </th>
                <th
                  style={{
                    backgroundColor: "#50868f",
                    color: "#fff",
                    padding: "16px",
                    textAlign: "left",
                    width: "15%",
                  }}
                >
                  Status
                </th>
                <th
                  style={{
                    backgroundColor: "#50868f",
                    color: "#fff",
                    padding: "16px",
                    textAlign: "left",
                    width: "25%",
                  }}
                >
                  Date
                </th>
                <th
                  style={{
                    backgroundColor: "#50868f",
                    color: "#fff",
                    padding: "16px",
                    textAlign: "left",
                    width: "20%",
                  }}
                >
                  Responses
                </th>
              </tr>
            </thead>
            <tbody>
              {player.feedback.map((fb) => (
                <tr
                  key={fb.call_id}
                  style={{
                    borderBottom: "1px solid #ddd",
                    transition: "background-color 0.3s ease",
                    ":hover": {
                      backgroundColor: "#f9f9f9",
                    },
                  }}
                >
                  <td style={{ padding: "16px", textAlign: "left" }}>
                    {fb.call_id}
                  </td>
                  <td style={{ padding: "16px", textAlign: "left" }}>
                    <div style={{ fontWeight: "500" }}>{fb.reason}</div>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "4px",
                      }}
                    >
                      Source: {fb.source}
                    </div>
                  </td>
                  <td style={{ padding: "16px", textAlign: "left" }}>
                    <span
                      style={{
                        padding: "6px 12px",
                        borderRadius: "12px",
                        backgroundColor:
                          fb.call_status === "resolved"
                            ? "#e6f7ee"
                            : fb.call_status === "pending"
                              ? "#fff8e6"
                              : "#ffe6e6",
                        color:
                          fb.call_status === "resolved"
                            ? "#10B981"
                            : fb.call_status === "pending"
                              ? "#FFA500"
                              : "#FF0000",
                        fontWeight: "500",
                        fontSize: "14px",
                      }}
                    >
                      {fb.call_status}
                    </span>
                  </td>
                  <td style={{ padding: "16px", textAlign: "left" }}>
                    {fb.feedback_responses[0]?.submitted_at
                      ? new Date(
                          fb.feedback_responses[0].submitted_at,
                        ).toLocaleString()
                      : "N/A"}
                  </td>
                  <td style={{ padding: "16px", textAlign: "left" }}>
                    {renderFeedbackResponses(fb.feedback_responses)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Feedback;
